var $08d7bccfda7015e7$exports = {};
$08d7bccfda7015e7$exports = {
    "endTime": `\u{7ED3}\u{675F}\u{65F6}\u{95F4}`,
    "startTime": `\u{5F00}\u{59CB}\u{65F6}\u{95F4}`,
    "time": `\u{65F6}\u{95F4}`
};


export {$08d7bccfda7015e7$exports as default};
//# sourceMappingURL=zh-CN.module.js.map
